/**
 * Wersja wbudowana dokumentów prawnych.
 *
 * Źródłem prawdy jest backend (`/api/v1/public/legal/{key}`), a te stałe są zapasem na brak
 * połączenia i na pierwszą klatkę renderu. Ekrany nie powinny ich importować bezpośrednio,
 * tylko przez `useLegalDocument` z `legalService`.
 *
 * Treść odpowiada temu, co siedzi w bazie. Gdy dokument zmieni się na backendzie, ten plik
 * trzeba odświeżyć przy najbliższym wydaniu, inaczej zapas z czasem pokazuje archeologię.
 */

export const REGULAMIN_TEXT = `1. Postanowienia ogólne
Niniejszy regulamin określa zasady korzystania z MyBeautyPlace w wersji dla klientów salonów, czyli z aplikacji mobilnej oraz z serwisu mybeautyplace.pl, które umożliwiają rezerwację wizyt w salonach kosmetycznych, fryzjerskich i spa, korzystanie z programów lojalnościowych tych salonów oraz wystawianie opinii.

2. Definicje
Usługodawca - GRUPA POMARAŃSKI I SOBOTA Sp. z o.o. z siedzibą w Krakowie, ul. Komuny Paryskiej 58A / 52, 30-389 Kraków (KRS: 0001238833, NIP: 6762719106, REGON: 544630139), operator platformy MyBeautyPlace.
Użytkownik - osoba fizyczna korzystająca z aplikacji.
Salon - podmiot świadczący usługi kosmetyczne zarejestrowany w platformie MyBeautyPlace.

3. Zasady korzystania z aplikacji
Użytkownik zobowiązuje się do podawania prawdziwych danych osobowych podczas rejestracji. Konto jest indywidualne i nie może być udostępniane osobom trzecim. Użytkownik ponosi odpowiedzialność za zachowanie poufności hasła.

4. Rezerwacje
Rezerwacja wizyty za pośrednictwem aplikacji stanowi umowę pomiędzy Użytkownikiem a Salonem. Usługodawca nie jest stroną tej umowy i pełni jedynie rolę pośrednika technicznego. Odwołanie wizyty powinno nastąpić zgodnie z zasadami określonymi przez dany Salon.

5. Płatności
Aplikacja nie pośredniczy w płatnościach. Za usługi płacisz bezpośrednio w Salonie, na zasadach ustalonych przez ten Salon. Korzystanie z samej aplikacji jest dla Użytkownika bezpłatne.

6. Program lojalnościowy i opinie
Punkty lojalnościowe nalicza i rozlicza Salon, według własnych zasad. Salon, który nie prowadzi programu lojalnościowego, punktów nie nalicza. Opinie o Salonie może wystawić Użytkownik, który odbył w nim wizytę. Usługodawca może usunąć opinię naruszającą prawo lub dobre obyczaje.

7. Odpowiedzialność
Usługodawca nie ponosi odpowiedzialności za jakość usług świadczonych przez Salony. Reklamacje dotyczące wykonanej usługi należy kierować bezpośrednio do Salonu. Reklamacje dotyczące działania samej aplikacji przyjmujemy pod adresem kontakt@mybeautyplace.pl i rozpatrujemy w terminie 14 dni.

8. Zmiany regulaminu
Usługodawca zastrzega sobie prawo do zmiany regulaminu. O zmianach Użytkownicy będą informowani za pośrednictwem aplikacji z wyprzedzeniem umożliwiającym rezygnację z usługi.

9. Kontakt
W sprawach związanych z regulaminem prosimy o kontakt na adres: kontakt@mybeautyplace.pl`;

export const PRYWATNOSC_TEXT = `1. Administrator danych

Administratorem danych osobowych jest GRUPA POMARAŃSKI I SOBOTA Sp. z o.o. z siedzibą w Krakowie, ul. Komuny Paryskiej 58A / 52, 30-389 Kraków (KRS: 0001238833, NIP: 6762719106, REGON: 544630139), operator platformy MyBeautyPlace. Kontakt w sprawach danych osobowych: kontakt@mybeautyplace.pl.

2. Czego dotyczy polityka

Polityka opisuje przetwarzanie danych w serwisie mybeautyplace.pl oraz w aplikacji mobilnej MyBeautyPlace, przeznaczonych dla klientów salonów beauty. Osobna polityka obowiązuje w aplikacji MyBeautyPlace Biz i w panelu internetowym, z których korzystają salony i ich pracownicy: biz.mybeautyplace.pl/polityka-prywatnosci.

3. Jakie dane przetwarzamy

Dane konta: imię, nazwisko, adres e-mail, opcjonalnie numer telefonu oraz sposób logowania (hasło albo konto Google lub Apple). Przy logowaniu przez Google lub Apple otrzymujemy wyłącznie identyfikator konta, adres e-mail i imię, w zakresie udostępnionym przez dostawcę.

Zdjęcie profilowe, jeśli zostanie dodane.

Dane rezerwacji: salon, usługa, termin, wybrany specjalista, status wizyty, historia wizyt oraz uwagi wpisane przy rezerwacji.

Program lojalnościowy: saldo punktów w poszczególnych salonach, historia naliczeń i odebrane nagrody.

Opinie: ocena, treść opinii oraz dołączone do niej zdjęcia. Opinia jest widoczna publicznie w profilu salonu razem z imieniem osoby, która ją wystawiła.

Kody połączenia z salonem: jednorazowe kody QR i kody potwierdzenia tożsamości, ważne kilka minut.

Dane techniczne: token urządzenia potrzebny do powiadomień push, adres IP, logi serwera oraz podstawowe informacje diagnostyczne. Nie korzystamy z narzędzi analitycznych, reklamowych ani z identyfikatora reklamowego, nie profilujemy i nie śledzimy użytkowników w innych aplikacjach ani serwisach.

4. Dane w salonie, w którym masz wizytę

W zakresie konta MyBeautyPlace administratorem danych jesteśmy my. Gdy połączysz konto z salonem lub zarezerwujesz wizytę, salon prowadzi własną kartotekę klienta i to salon jest administratorem danych w niej zawartych, w tym notatek zabiegowych, dokumentów i zgód. My przetwarzamy te dane w imieniu salonu jako podmiot przetwarzający, na podstawie umowy powierzenia. Pytania o dane w kartotece kieruj bezpośrednio do salonu.

5. Cele i podstawy prawne

Prowadzenie konta, obsługa rezerwacji, programu lojalnościowego i opinii: art. 6 ust. 1 lit. b RODO (wykonanie umowy).

Powiadomienia push o wizytach oraz komunikacja marketingowa: art. 6 ust. 1 lit. a RODO (zgoda), którą możesz wycofać w każdej chwili.

Bezpieczeństwo, zapobieganie nadużyciom, rozwój usługi oraz ustalenie, dochodzenie lub obrona roszczeń: art. 6 ust. 1 lit. f RODO (uzasadniony interes).

Obowiązki wynikające z przepisów, w tym rozliczeniowe: art. 6 ust. 1 lit. c RODO.

6. Powiadomienia push

Aplikacja mobilna wysyła powiadomienia o potwierdzeniu rezerwacji, zmianie terminu, przypomnieniu o wizycie i naliczonych punktach. Do ich dostarczenia używamy tokena urządzenia. Zgodę na powiadomienia możesz w każdej chwili cofnąć w ustawieniach systemowych telefonu.

7. Odbiorcy danych i podprocesorzy

Salony, z którymi połączysz konto lub w których zarezerwujesz wizytę, w zakresie potrzebnym do realizacji wizyty.

Google i Apple: logowanie do serwisu i aplikacji.

Expo oraz Google (Firebase Cloud Messaging) i Apple (APNs): dostarczanie powiadomień push.

Brevo: wysyłka wiadomości e-mail, w tym potwierdzeń rejestracji i resetu hasła.

Dostawca hostingu w Unii Europejskiej: przechowywanie danych.

Nie sprzedajemy danych i nie udostępniamy ich brokerom danych ani sieciom reklamowym.

8. Przekazywanie poza EOG

Część dostawców (m.in. Google, Apple, Expo) może przetwarzać dane poza Europejskim Obszarem Gospodarczym, na podstawie standardowych klauzul umownych zatwierdzonych przez Komisję Europejską lub innych zgodnych z prawem mechanizmów.

9. Okres przechowywania

Dane konta przechowujemy przez czas korzystania z usługi, a po jego zakończeniu przez okres wymagany przepisami lub potrzebny do obrony przed roszczeniami. Kody połączenia z salonem wygasają po kilku minutach i są usuwane. Dane w kartotece klienta prowadzonej przez salon podlegają okresom przechowywania ustalonym przez ten salon.

10. Usunięcie konta

Konto usuniesz samodzielnie w każdej chwili: w aplikacji mobilnej w sekcji Profil, Ustawienia i konto, a w serwisie internetowym w zakładce Profil. Usunięcie konta odłącza je od wszystkich salonów, anuluje oczekujące prośby o połączenie, kasuje kody połączenia i dezaktywuje konto, przez co przestaje ono być dostępne do logowania. Kartoteka klienta prowadzona przez salon pozostaje u salonu jako odrębnego administratora, a wniosek o jej usunięcie kieruj do salonu.

11. Twoje prawa

Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia i ograniczenia przetwarzania, prawo do przenoszenia danych, prawo sprzeciwu wobec przetwarzania opartego na uzasadnionym interesie oraz prawo do cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania sprzed jej cofnięcia. Wnioski przyjmujemy pod adresem kontakt@mybeautyplace.pl. Przysługuje Ci także skarga do Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.

12. Pliki cookies i pamięć lokalna

Serwis internetowy przechowuje w pamięci lokalnej przeglądarki dane sesji, czyli tokeny logowania i wybrane ustawienia. Aplikacja mobilna trzyma te dane w zabezpieczonym magazynie systemowym. Nie stosujemy cookies analitycznych ani reklamowych. Zapisane dane sesji możesz w każdej chwili usunąć, wylogowując się lub czyszcząc dane witryny w przeglądarce.

13. Bezpieczeństwo danych

Stosujemy środki techniczne i organizacyjne chroniące dane przed nieuprawnionym dostępem, utratą lub zniszczeniem. Dane przesyłane są z wykorzystaniem szyfrowania TLS.

14. Dzieci

Usługa nie jest kierowana do osób poniżej 16. roku życia i nie zbieramy świadomie ich danych. Jeśli takie dane trafią do nas przez pomyłkę, usuniemy je po zgłoszeniu na kontakt@mybeautyplace.pl.

15. Zmiany polityki

O istotnych zmianach polityki poinformujemy w aplikacji lub wiadomością e-mail. Aktualna wersja jest zawsze dostępna pod tym adresem, wraz z datą ostatniej aktualizacji.

), }, ];

return ( navigate(-1)}> navigate('/')}> MyBeautyPlace ); }

export default InfoPage;

16. Kontakt

W sprawach dotyczących ochrony danych osobowych prosimy o kontakt: kontakt@mybeautyplace.pl.`;
